import { Injectable, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export const ConfigServiceToken = new InjectionToken('config.service');

@Injectable()
export class ConfigService {
  config: Object;

  constructor(private http: HttpClient) {}

  async load(): Promise<any> {
    this.config = await this.http.get('/wdpr-web-dcl-homepage/config').toPromise();

    return this.config;
  }

  getValue(key: string): any {
    // Get value of config key:
    return this.config[key];
  }
}
